import FlashQuotesScreen from './FlashQuotesScreen';

export default FlashQuotesScreen;